import React from 'react';
import '@pqina/flip/dist/flip.min.css';
import { Icon } from 'learning-panel-components';
import styles from './eventDate.module.scss';

interface EventDateProps {
    dateTime: Date;
    locale: string;
}

const EventDate: React.FC<EventDateProps> = ({ dateTime, locale }) => {
    return (
        <div className={styles['event-date-wrapper']}>
            <Icon name="calendar" style={{ color: 'rgba(247, 249, 168, 1)', height: '24px', marginLeft: '1rem' }} />
            <div className={styles['event-date-text']}>
                {`${dateTime.toLocaleDateString(locale, {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                })}, ${dateTime.toLocaleTimeString(locale, { hour: 'numeric', minute: 'numeric' })}`}
            </div>
        </div>
    );
};

export default EventDate;
